/* eslint-disable react/prop-types */
import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';

// Month+Year only — no day grid, no day selection. value/onChange use plain
// JS Date objects (matches how AppointmentCalendarView's monthDate state works).
export default function MonthYearPicker({ label, value, onChange }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        views={['year', 'month']}
        openTo="month"
        inputFormat="MMMM YYYY"
        value={dayjs(value)}
        onChange={newVal => newVal?.isValid() && onChange(newVal.toDate())}
        renderInput={params => (
          <TextField {...params} size="small" fullWidth sx={{ '& .MuiOutlinedInput-root': { minHeight: 36 } }} />
        )}
      />
    </LocalizationProvider>
  );
}
